module.exports = __webpack_public_path__ + "20_big.jpg?9df46f6e131dcd44141bdcadc4b8051e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/20_big.jpg
// module id = 170
// module chunks = 0